import { api } from '@/api/client';
export async function fetchMyProfile() {
    const { data } = await api.get('/v1/me');
    return data;
}
export async function updateMyProfile(payload) {
    const { data } = await api.patch('/v1/me', payload);
    return data;
}
export async function fetchMyOrders() {
    const { data } = await api.get('/v1/me/orders');
    return data;
}
export async function fetchMyOrder(orderId) {
    const { data } = await api.get(`/v1/me/orders/${orderId}`);
    return data;
}
export async function resumeOrderPayment(orderId) {
    const { data } = await api.post(`/v1/me/orders/${orderId}/payment-link`);
    return data;
}
